<template>
  <v-app :class="themeMode === 'default' ? 'bg-primary' : ''">
    <v-alert
      v-if="activePage !== 'splash' && info.top_banner && info.top_banner.length > 2"
      dense color="primary" class="text-center pa-2 text-error"
    >
      {{ info.top_banner }}
    </v-alert>

    <v-main>
      <slot />
    </v-main>

    <slot name="dialogs" />

    <!-- toggle فقط توی splash - در بقیه صفحات توی top_bar هست -->
    <div v-if="activePage === 'splash'" style="position: fixed; bottom: 16px; left: 16px; z-index: 999;">
      <v-menu location="top start" :close-on-content-click="true">
        <template #activator="{ props }">
          <v-btn v-bind="props" :icon="themeModeIcon" variant="tonal" size="small" />
        </template>
        <v-list density="compact" min-width="140" rounded="lg">
          <v-list-item
            v-for="item in themeModes" :key="item.value"
            :prepend-icon="item.icon" :title="item.label"
            :active="themeMode === item.value"
            @click="$store.commit('setThemeMode', item.value)"
          />
        </v-list>
      </v-menu>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'DefaultLayout',
  data: () => ({
    themeModes: [
      { value: 'default', label: 'پیش‌فرض', icon: 'mdi-palette'      },
      { value: 'light',   label: 'روشن',    icon: 'mdi-weather-sunny' },
      { value: 'dark',    label: 'تاریک',   icon: 'mdi-weather-night' },
    ],
  }),
  computed: {
    activePage()    { return this.$store.state.activePage; },
    info()          { return this.$store.state.info; },
    themeMode()     { return this.$store.state.themeMode; },
    themeModeIcon() {
      return {
        default: 'mdi-palette',
        light:   'mdi-weather-sunny',
        dark:    'mdi-weather-night',
      }[this.themeMode] ?? 'mdi-palette';
    },
  },
};
</script>
